import { useState } from 'react';
import { GovDropdown } from '@gov-design-system-ce/react/gov-button';
import { GovFormControl } from '@gov-design-system-ce/react/gov-form';
import { GovIcon } from '@gov-design-system-ce/react/gov-icon';
import { GovTag } from '@gov-design-system-ce/react/gov-tag';
import type { DatovkaApiType } from '@gov-nx/api/types/databoxTypes';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box/providers/MessageFormContext';
import { dataBoxLabel } from '@gov-nx/module/data-box/utils/dataBox';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { Button } from '../../Button/Button';
import { DataBoxRecipientDetailContent } from './DataBoxRecipientDetailContent';

export const DataBoxRecipientDetail = ({
	dataBox,
}: {
	dataBox: DatovkaApiType;
}) => {
	const { onRecipientRemove } = useDataBoxMessageFormContext();
	const [showDetail, setShowDetail] = useState(false);
	const { t: tn } = useLocale(PageCode['datove-schranky']);

	return (
		<GovFormControl className="ds-new-message ds-recipient-detail">
			<label className="gov-form-label__label">
				{tn('nova-zprava.komu')}:
				<span className="gov-color--text-status-error">&nbsp;*</span>
			</label>
			<GovDropdown
				position="left"
				color="primary"
				type="base"
				size="s"
				open={showDetail}
				label={
					<GovTag
						color="primary"
						size="s"
						type="subtle"
						className="pr-0!"
						onGov-click={() => setShowDetail(true)}>
						<span className="truncate">{dataBoxLabel(dataBox, true)}</span>
						<Button
							color="primary"
							type="base"
							aria-label={tn('nova-zprava.zavrit-vse')}
							size="s"
							onClick={onRecipientRemove}>
							<GovIcon
								slot="icon-end"
								name="x-lg"
								type="components"
							/>
						</Button>
					</GovTag>
				}>
				<DataBoxRecipientDetailContent dataBox={dataBox} />
			</GovDropdown>
		</GovFormControl>
	);
};
